import { UserStatus, messageUserStatus } from "@version2/domain-package";
import React from "react";
import type { HookAPI } from "@version2/ui-package";

type AccountBlockedModalProps = {
  modal: HookAPI;
  userStatus: UserStatus;
  message?: string;
};

export const accountBlockedModal = ({
  modal,
  userStatus,
  message,
}: AccountBlockedModalProps) => {
  modal.error({
    title: `Your account has been ${userStatus}`,
    content: (
      <div>
        <p>{message || messageUserStatus(userStatus)}</p>
        <p>If you have any questions, please contact us.</p>
      </div>
    ),
    onOk() {},
  });
};

export default accountBlockedModal;
